// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5733":"7903566320a4a7ee","8963":"643e0fef0a801e2f"}[chunkId] + ".js";
};